import { createSlice } from "@reduxjs/toolkit";

// Initial state
const initialState = {
  childLeads: [],
  selectedLead: {},
  parentLead: {},
  mode: "",
  stats: {
    enquiries: 0,
    enquiryLeads: 0,
    customerLeads: 0,
  },
  leads: [
    // Additional dummy leads can follow similar structure
  ],
  //   dummyLeads: [
  //     {
  //       id: 1,
  //       name: "John Doe",
  //       status: "fresh",
  //       lead_type: "abroad_counseling",
  //       created_at: "2024-01-01",
  //       branch: "Branch 1",
  //       call_handled_by: "Agent A",
  //     },
  //     {
  //       id: 2,
  //       name: "Jane Smith",
  //       status: "enquiry",
  //       lead_type: "career_counseling",
  //       created_at: "2024-01-05",
  //       branch: "Branch 2",
  //       call_handled_by: "Agent B",
  //     },
  //   ],
  filters: {
    assignedFilter: "",
    statusFilter: "",
    typeFilter: "",
    callHandledByFilter: "",
    fromDateFilter: "",
    toDateFilter: "",
  },
  filteredLeads: [
    {
      name: "Alex Johnson",
      phone: "+9876543210",
      email: "alex.johnson@example.com",
      address: "456 Elm Street, Metropolis, TX 54321",
      status: "interested",
      lead_type: "career_counseling",
      tags: ["career", "guidance", "development"],
      description: "Interested in exploring career options in technology.",
      call_handled_by: "Agent B",
      branch: "Branch 2",
      contacted_today: false,
      reference_source: ["Friend", "Online Search"],
      reference_of_friend_relative: "Friend",
      reference_name: "Charlie Brown",
      residence_city: "Metropolis",
      residence_state: "Texas",
      current_education: "Bachelor's Degree in Computer Science",
      school_college_name: "Metropolis University",
      last_qualification: "Bachelor's Degree",
      last_qualification_percentage: 88.7,
      subjects_liked: ["Programming", "Algorithms"],
      subjects_disliked: ["History"],
      previous_education_history: [
        {
          institution: "Tech High School",
          degree: "High School Diploma",
          percentage: 90,
        },
      ],
      average_gpa_percentage: 3.9,
      job_internship_details: [
        {
          organization: "TechCorp",
          role: "Software Developer Intern",
          duration: "3 months",
        },
      ],
      countries_for_abroad_studies: ["Canada", "Australia"],
      other_countries_abroad: "New Zealand",
      intended_courses_shortlisted: ["Data Science", "AI and ML"],
      intake_year: "2025",
      college_university_of_study: "Global Tech University",
      personal_attributes: ["Dedicated", "Analytical"],
      other_attributes: "Strong problem-solving skills",
      hobbies: ["Coding", "Gaming", "Music"],
      competitions_participated: ["Hackathon 2023", "Math Challenge 2022"],
      avid_reader: true,
      favorite_theory_subjects: ["Artificial Intelligence"],
      specific_career_goals: "To become a leading AI researcher",
      career_choices_reasons: "Fascination with solving complex problems",
      plans_to_study_abroad_future: true,
      parents_occupation: "Engineer",
      join_family_business: false,
      technology_innovation_details: "Created an app for time management",
      associated_with_ngo: "Volunteered at CodeForGood",
      interest_in_politics_public_service: true,
      politics_public_service_reason: "Interest in improving tech policies",
      interested_in_fashion_design: false,
      interested_in_construction_models: false,
      leadership: ["President of Coding Club"],
      volunteer: ["Community Tech Workshop"],
      sport_art: ["Soccer", "Sketching"],
      interested_in_food_nutrition: false,
      interested_in_film_career: false,
      test_preparation_required: ["GRE", "TOEFL"],
      other_exams: ["IELTS"],
      study_abroad: true,
      exam_date: "2025-03-15",
      preferred_mode_of_teaching: "Hybrid",
      visa_country_name: "Canada",
      other_country_visa: "Germany",
      special_requests_info: "Needs guidance for accommodation",
      guardian_contact_number: "+1231231234",
      guardian_residence_place: "Springfield, TX",
      guardian_name: "Laura Johnson",
      personal_introduction:
        "I am a tech enthusiast with a passion for learning.",
      additional_remarks: "Follow-up scheduled for March 2025.",
      created_at: new Date().toISOString(),
      lead_notes: "Needs personalized counseling for tech careers.",
      contacted_at: "2024-12-10",
    },
    {
      name: "Emma Williams",
      phone: "+1122334455",
      email: "emma.williams@example.com",
      address: "123 Main Street, Gotham, NY 12345",
      status: "fresh",
      lead_type: "abroad_counseling",
      tags: ["education", "study abroad"],
      description: "Looking for universities in the USA and Canada.",
      call_handled_by: "Agent A",
      branch: "Branch 1",
      contacted_today: true,
      reference_source: ["Online Ad"],
      reference_of_friend_relative: "",
      reference_name: null,
      residence_city: "Gotham",
      residence_state: "New York",
      current_education: "Master's in Biotechnology",
      school_college_name: "NYC University",
      last_qualification: "Bachelor's Degree",
      last_qualification_percentage: 91.5,
      subjects_liked: ["Biology", "Chemistry"],
      subjects_disliked: ["Physics"],
      previous_education_history: [
        {
          institution: "Metro High School",
          degree: "High School Diploma",
          percentage: 89,
        },
      ],
      average_gpa_percentage: 3.7,
      job_internship_details: [
        {
          organization: "BioTech Labs",
          role: "Research Assistant",
          duration: "1 year",
        },
      ],
      countries_for_abroad_studies: ["USA", "Canada"],
      other_countries_abroad: "Australia",
      intended_courses_shortlisted: ["Biotechnology", "Pharmaceuticals"],
      intake_year: "2026",
      college_university_of_study: "Global Bio University",
      personal_attributes: ["Hardworking", "Innovative"],
      other_attributes: "Team player",
      hobbies: ["Reading", "Traveling"],
      competitions_participated: ["BioTech Hackathon"],
      avid_reader: false,
      favorite_theory_subjects: ["Genetics"],
      specific_career_goals: "To work in a leading pharmaceutical company",
      career_choices_reasons: "Passion for improving healthcare",
      plans_to_study_abroad_future: true,
      parents_occupation: "Doctor",
      join_family_business: false,
      technology_innovation_details: "Developed a new lab analysis technique",
      associated_with_ngo: "Member of Clean Water Initiative",
      interest_in_politics_public_service: false,
      politics_public_service_reason: "",
      interested_in_fashion_design: false,
      interested_in_construction_models: false,
      leadership: ["Lead Researcher in School Project"],
      volunteer: ["Community Health Drive"],
      sport_art: ["Tennis", "Drawing"],
      interested_in_food_nutrition: true,
      interested_in_film_career: false,
      test_preparation_required: ["GRE"],
      other_exams: [],
      study_abroad: true,
      exam_date: "2025-05-20",
      preferred_mode_of_teaching: "Offline",
      visa_country_name: "USA",
      other_country_visa: "",
      special_requests_info: "Assistance with scholarships",
      guardian_contact_number: "+1122339988",
      guardian_residence_place: "Gotham, NY",
      guardian_name: "Michael Williams",
      personal_introduction: "I aim to contribute to biotechnology research.",
      additional_remarks: "Needs scholarship details.",
      created_at: new Date().toISOString(),
      lead_notes: "Send follow-up email about test prep.",
      contacted_at: "2024-12-14",
    },
    // Additional dummy leads can follow similar structure
  ],
  currentLead: null, // For viewing/editing a specific lead
  totalEnquiries: 0, // Total number of enquiries
  enquiriesToLead: 0, // Number of enquiries converted to leads
  loading: false, // For async operations
  error: null, // Error handling
};

const leadsSlice = createSlice({
  name: "leads",
  initialState,
  reducers: {
    // Add a new lead
    // addLead: (state, action) => {
    //   const newLead = action.payload;
    //   state.leads.push(newLead);

    //   // Update total enquiries
    //   state.totalEnquiries += 1;

    //   // Update enquiriesToLead if the lead has been converted
    //   if (newLead.status && newLead.status.toLowerCase() === "customer") {
    //     state.enquiriesToLead += 1;
    //   }
    // },
    // // Update an existing lead
    // updateLead: (state, action) => {
    //   const updatedLead = action.payload;
    //   const index = state.leads.findIndex((lead) => lead.id === updatedLead.id);

    //   if (index !== -1) {
    //     const previousLead = state.leads[index];
    //     state.leads[index] = updatedLead;

    //     // Update enquiriesToLead if the status changes
    //     if (
    //       previousLead.status.toLowerCase() !== "customer" &&
    //       updatedLead.status.toLowerCase() === "customer"
    //     ) {
    //       state.enquiriesToLead += 1;
    //     } else if (
    //       previousLead.status.toLowerCase() === "customer" &&
    //       updatedLead.status.toLowerCase() !== "customer"
    //     ) {
    //       state.enquiriesToLead -= 1;
    //     }
    //   }
    // },
    addLead: (state, action) => {
      const newLead = action.payload;

      // Add the new lead to the main leads array
      state.leads = [...state.leads, newLead];

      // Check if the new lead matches the current filters
      const {
        assignedFilter,
        statusFilter,
        typeFilter,
        callHandledByFilter,
        fromDateFilter,
        toDateFilter,
      } = state.filters;

      let isMatch = true;

      if (assignedFilter) {
        isMatch = isMatch && newLead.assigned === assignedFilter; // Compare IDs for `assigned`
      }
      if (statusFilter) {
        isMatch = isMatch && newLead.status === statusFilter;
      }
      if (typeFilter) {
        isMatch = isMatch && newLead.lead_type === typeFilter;
      }
      if (callHandledByFilter) {
        isMatch = isMatch && newLead.call_handled_by === callHandledByFilter; // Compare IDs for `call_handled_by`
      }
      if (fromDateFilter) {
        isMatch =
          isMatch && new Date(newLead.created_at) >= new Date(fromDateFilter);
      }
      if (toDateFilter) {
        isMatch =
          isMatch && new Date(newLead.created_at) <= new Date(toDateFilter);
      }

      // Add the new lead to filteredLeads only if it matches the filters
      if (isMatch) {
        state.filteredLeads = [...state.filteredLeads, newLead];
      }
    },

    setLeads: (state, action) => {
      // Update the leads array
      state.leads = action.payload;

      // If no filters are applied, set filteredLeads to include all leads
      const {
        assignedFilter,
        statusFilter,
        typeFilter,
        callHandledByFilter,
        fromDateFilter,
        toDateFilter,
      } = state.filters;

      const isAnyFilterApplied =
        assignedFilter ||
        statusFilter ||
        typeFilter ||
        callHandledByFilter ||
        fromDateFilter ||
        toDateFilter;

      if (!isAnyFilterApplied) {
        // If no filters are applied, show all leads
        state.filteredLeads = [...state.leads];
      } else {
        // Otherwise, apply filters
        state.filteredLeads = state.leads.filter((lead) => {
          let isMatch = true;

          if (assignedFilter) {
            isMatch = isMatch && lead.assigned === assignedFilter; // Compare IDs for `assigned`
          }
          if (statusFilter) {
            isMatch = isMatch && lead.status === statusFilter;
          }
          if (typeFilter) {
            isMatch = isMatch && lead.lead_type === typeFilter;
          }
          if (callHandledByFilter) {
            isMatch = isMatch && lead.call_handled_by === callHandledByFilter; // Compare IDs for `call_handled_by`
          }
          if (fromDateFilter) {
            isMatch =
              isMatch && new Date(lead.created_at) >= new Date(fromDateFilter);
          }
          if (toDateFilter) {
            isMatch =
              isMatch && new Date(lead.created_at) <= new Date(toDateFilter);
          }

          return isMatch;
        });
      }
    },
    setSelectedLead: (state, action) => {
      state.selectedLead = action.payload;
    },
    setChildLeads: (state, action) => {
      state.childLeads = action.payload;
    },
    setParentLead: (state, action) => {
      state.parentLead = action.payload;
    },
    setMode: (state, action) => {
      state.mode = action.payload;
    },
    setStats: (state, action) => {
      state.stats = action.payload;
    },
    setFilters: (state, action) => {
      // Update the filters state with the new filter values
      state.filters = { ...state.filters, ...action.payload };

      const {
        assignedFilter,
        statusFilter,
        typeFilter,
        callHandledByFilter,
        fromDateFilter,
        toDateFilter,
      } = state.filters;

      // Apply filters to the leads array
      state.filteredLeads = state.leads.filter((lead) => {
        let isMatch = true;

        if (assignedFilter) {
          // Ensure `lead.assigned` matches the filter
          isMatch = isMatch && lead.assigned === parseInt(assignedFilter, 10);
        }
        if (statusFilter) {
          isMatch =
            isMatch && lead.status.toLowerCase() === statusFilter.toLowerCase();
        }
        if (typeFilter) {
          isMatch =
            isMatch &&
            lead.lead_type.toLowerCase() === typeFilter.toLowerCase();
        }
        if (callHandledByFilter) {
          // Ensure `lead.call_handled_by` matches the filter
          isMatch =
            isMatch &&
            lead.call_handled_by === parseInt(callHandledByFilter, 10);
        }
        if (fromDateFilter) {
          isMatch =
            isMatch && new Date(lead.created_at) >= new Date(fromDateFilter);
        }
        if (toDateFilter) {
          isMatch =
            isMatch && new Date(lead.created_at) <= new Date(toDateFilter);
        }

        return isMatch;
      });
    },

    // updateLead: (state, action) => {
    //   const updatedLead = action.payload;
    //   state.leads = state.leads.map((lead) =>
    //     lead.id === updatedLead.id ? updatedLead : lead
    //   );
    // },

    updateLead: (state, action) => {
      const updatedLead = action.payload;
      state.leads = state.leads.map((lead) =>
        lead.id === updatedLead.id ? updatedLead : lead
      );

      // Update filteredLeads to reflect the changes
      state.filteredLeads = state.filteredLeads.map((lead) =>
        lead.id === updatedLead.id ? updatedLead : lead
      );
    },

    // Delete a lead
    deleteLead: (state, action) => {
      const leadId = action.payload;
      const leadToDelete = state.leads.find((lead) => lead.id === leadId);

      if (leadToDelete) {
        // Update enquiriesToLead if the deleted lead was a converted lead
        if (leadToDelete.status.toLowerCase() === "customer") {
          state.enquiriesToLead -= 1;
        }

        // Remove the lead
        state.leads = state.leads.filter((lead) => lead.id !== leadId);

        // Update total enquiries
        state.totalEnquiries -= 1;
      }
    },
    // Set the current lead for editing/viewing
    setCurrentLead: (state, action) => {
      state.currentLead = action.payload;
    },
    // Reset the current lead
    resetCurrentLead: (state) => {
      state.currentLead = null;
    },
    // Handle loading state
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    // Handle error state
    setError: (state, action) => {
      state.error = action.payload;
    },
  },
});

// Export actions
export const {
  addLead,
  setLeads,
  setFilters,
  updateLead,
  deleteLead,
  setCurrentLead,
  resetCurrentLead,
  setLoading,
  setSelectedLead,
  setParentLead,
  setChildLeads,
  setError,
  setMode,
  setStats,
} = leadsSlice.actions;

// Export reducer
export default leadsSlice.reducer;
